document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll('.service__select-list a');
    const elements = document.querySelectorAll('.service__map .service__map-item');

    function updateActiveClasses (clickedLink) {
        links.forEach(function (link) {
            if (link === clickedLink) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });

        const clickedArea = clickedLink.getAttribute('data-area');
        elements.forEach(function (element) {
            const area = element.getAttribute('data-area');
            if (area) {
                if (area === clickedArea) {
                    element.classList.add('active');
                    const placeholder = document.querySelector(".service__map-placeholder");
                    placeholder.classList.add("hidden");
                } else {
                    element.classList.remove('active');
                }
            }
        });
    }

    links.forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            updateActiveClasses(link);
        });
    });
});
